export default [
  {
    requirement: "not **wind and water tight**",
    id: 'wind-water-tight',
  },
  {
    requirement: "not **reasonably fit for human habitation**",
    id: 'fit-for-habitation',
  },
  {
    requirement:
      "supply of **water, gas, and electricity** not in a reasonable state of repair",
    id: 'supply',
  },
  {
    requirement:
      "**fittings, fixtures, appliances and furnishings** not in a reasonable state of repair",
    id: 'repair',
  },
  {
    requirement:
      "no satisfactory provision for **food storage and preparation**",
    id: 'food',
  },
  {
    requirement: "**common parts of the house** cannot be safely accessed",
    id: 'safe-access',
  },
  {
    requirement: "**common tenement door** not secure",
    id: 'secure-door',
  },
  {
    requirement: "is not **structurally stable**",
    id: 'structurally-stable',
  },
  {
    requirement:
      "is not substantially **free from rising or penetrating damp**",
    id: 'damp'
  },
  {
    requirement:
      "does not have satisfactory provision for **natural and artificial lighting, for ventilation and for heating**",
    id: 'light-vent-heat',
  },
  {
    requirement: "does not have satisfactory **thermal insulation**",
    id: 'insulation',
  },
  {
    requirement:
      "does not have an adequate **piped supply of wholesome water** available within the house",
    id: 'potable-water',
  },
  {
    requirement:
      "does not have a sink provided with a satisfactory **supply of both hot and cold water** within the house",
    id: 'hot-cold-water'
  },
  {
    requirement:
      "does not have a **water closet, or waterless closet**, available for the exclusive use of the occupants of the house and suitably located within the house",
    id: 'water-closet',
  },
  {
    requirement:
      "does not have a fixed **bath or shower and a wash-hand basin**, all of which must have a satisfactory supply of hot and cold water and be suitably located in the house",
    id: 'bath',
  },
  {
    requirement:
      "does not have an effective system for the **drainage and disposal of foul and surface water**",
    id: 'drainage'
  },
  {
    requirement:
      "does not have a **supply of electricity**, where electricity is supplied to the property, that complies with the relevant requirements in relation to electrical installation for that supply and is adequate and safe to use",
    id: 'electricity',
  },
  {
    requirement:
      "does not have satisfactory **facilities for the cooking of food** within the house",
    id: 'cooking-facilities',
  },
  {
    requirement:
      "does not have satisfactory **access to all external doors** and outbuildings",
    id: 'access',
  },
  {
    requirement:
      "does not have satisfactory **equipment installed for detecting fire**, and for giving warning of fire or suspected fire",
    id: 'fire-safety',
  },
  {
    requirement:
      "does not have satisfactory **equipment installed for detecting, and for giving warning of, carbon monoxide** present in a concentration that is hazardous to health",
    id: 'carbon-monoxide',
  },
]